// extracted by mini-css-extract-plugin
export default {"wrapper":"Hq-z","response":"Iq-z","error":"Jq-z","disabled":"Kq-z","buttons":"Lq-z","feedbackQuestionSection":"Mq-z","yesNoWrapper":"Nq-z"};